import React from "react"
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Type from "./Type";
import "./Home.css";

function ContentHome() {
  return (
    <div>
      <section>
        <Container fluid className="home-section" id="home">
          <Container className="home-content">
            <Row>
              <Col md={7} className="home-header">
                <h1 className="heading">
                  Hola!
                  <span className="wave" role="img" aria-labelledby="wave">
                    👋🏻
                  </span>
                </h1>

                <h1 className="heading-name">
                  Soy:
                  <strong className="text-custom" style={{ color: "red" }}>
                    {" "}
                    EMISAEL KISLER
                  </strong>
                </h1>

                <div
                  className="text-custom"
                  id="text-type"
                  style={{
                    padding: 50,
                    textAlign: "left",
                    color: "red",
                    fontSize: "30px",
                  }}
                >
                  <Type />
                </div>
              </Col>

              <Col md={5} style={{ paddingBottom: 10 }}>
                <img
                  src="./home-main.webp"
                  alt="EK"
                  className="img-fluid"
                  style={{
                    marginTop: "-80px",
                    width: "400px",
                    height: "350px",
                  }}
                />
              </Col>
            </Row>
          </Container>
        </Container>
      </section>
    </div>
  );
}

export default ContentHome;
